import { HttpEvent, HttpEventType } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { PlansService } from '@service/plans.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-second-words-plan',
  templateUrl: './second-words-plan.component.html',
  styleUrls: ['./second-words-plan.component.scss']
})
export class SecondWordsPlanComponent implements OnInit {

  public canSendReceipt: boolean = false;
  fileData: File = null;
  qrCodeLink: string;

  constructor(
    private plansService: PlansService,
    private toast: ToastrService,
  ) { }

  ngOnInit() {
    this.plansService.pixRequest(2499).subscribe(res => {
      this.qrCodeLink = res.Item.pix.link_qr_code
    });
  }

  fileChangeEvent(fileInput: any) {
    this.fileData = <File>fileInput.target.files[0];
  }

  upload() {
    if (!this.fileData) {
      this.toast.error('Por favor, envie um comprovante em PDF.');
      return;
    }
    const formData = new FormData();
    formData.append('file', this.fileData);
    formData.append('days', '30');
    formData.append('value', '2499');

    this.plansService.sendReceipt(formData).subscribe((event: HttpEvent<any>) => {
      if (event.type === HttpEventType.UploadProgress) {
        console.log('Upload progress: ', Math.round(event.loaded / event.total * 100) + '%');
      } else if (event.type === HttpEventType.Response) {
        if (event.body.voucher_expires_at) {
          this.toast.success('Seu comprovante foi validado!');
          const user = JSON.parse(localStorage.getItem('currentUser'));
          if (user) {
            user.voucher_expires_at = event.body.voucher_expires_at;
            localStorage.setItem('currentUser', JSON.stringify(user));
          }
        } else {
          this.toast.error('Por favor, envie um comprovante válido!');
        }
      }
    });
  }
}
